import { useNotifier } from '@bowtie-web/common/lib/notification';
import { Toaster } from '@bowtie-web/components/lib';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useMemo } from 'react';

const Notifier = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const { notifications, dismiss } = useNotifier();
  const toasts = useMemo(() => {
    return Array.from(notifications)
      .reverse()
      .map(([, notification]) => notification);
  }, [notifications]);
  return (
    <Toaster
      placement={matches ? 'bottom' : 'top-right'}
      toasts={toasts}
      onDismiss={dismiss}
    />
  );
};

export default Notifier;
